const ComplementoPagosaextranjerosRules = ( EsBenefEfectDelCobro ) => {
  let requiredSI = 'string';
  let requiredNO = 'string';

  if (EsBenefEfectDelCobro === 'SI') {
    requiredSI = 'required';
  }

  if (EsBenefEfectDelCobro === 'NO') {
    requiredNO = 'required';
  }

  return {
    EsBenefEfectDelCobro: ['required', 'string', 'in:SI,NO'],
    NoBeneficiario: {
      PaisDeResidParaEfecFisc: [
        requiredNO,
        'string',
        'in:AF,AL,DE,AD,AO,AI,AQ,AG,AN,SA,DZ,AR,AM,AW,AU,AT,AZ,BS,BH,BD,BB,BE,BZ,BJ,BM,BY,BO,BA,BW,BR,BN,BG,BF,BI,BT,CV,TD,KY,KH,CM,CA,CL,CN,CY,VA,CC,CO,KM,CG,CK,KP,KR,CI,CR,HR,CU,DK,DJ,DM,EC,EG,SV,AE,ER,SI,ES,FM,US,EE,ET,FJ,PH,FI,FR,GA,GM,GE,GH,GI,GD,GR,GL,GP,GU,GT,GG,GW,GQ,GN,GF,GY,HT,HN,HK,HU,IN,ID,IQ,IR,IE,IS,BV,IM,AX,FO,GS,HM,FK,MP,MH,UM,SB,SJ,TK,WF,IL,IT,JM,JP,JE,JO,KZ,KE,KI,KW,KG,LS,LV,LB,LR,LY,LI,LT,LU,MO,MK,MG,MY,MW,MV,ML,MT,MA,MQ,MU,MR,YT,MX,MD,MC,MN,MS,ME,MZ,MM,NA,NR,CX,NP,NI,NE,NG,NU,NF,NO,NC,NZ,OM,PIK,NL,PK,PW,PS,PA,PG,PY,PE,PN,PF,PL,PT,PR,QA,GB,CZ,CF,LA,RS,DO,SK,CD,RW,RE,RO,RU,EH,WS,AS,BL,KN,SM,MF,PM,VC,SH,LC,ST,SN,SC,SL,SG,SY,SO,LK,ZA,SD,SE,CH,SR,SZ,TJ,TH,TW,TZ,IO,TF,TL,TG,TO,TT,TN,TC,TM,TR,TV,UA,UG,UY,UZ,VU,VE,VN,VG,VI,YE,ZM,ZW',
      ],
      ConceptoPago: [
        requiredNO,
        'string',
        'in:1,2,3,4,5,6,7,8,9',
      ],
      DescripcionConcepto: [
        requiredNO,
        'string',
        'min:1',
        'max:255',
      ],
    },
    Beneficiario: {
      RFC: [
        requiredSI,
        'string',
        'min:12',
        'max:13',
        'regex:/^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9][A-Z,0-9][0-9,A-Z]$/',
      ],
      CURP: [
        requiredSI,
        'string',
        'size:18',
        'regex:/^[A-Z][A,E,I,O,U,X][A-Z]{2}[0-9]{2}[0-1][0-9][0-3][0-9][M,H][A-Z]{2}[B,C,D,F,G,H,J,K,L,M,N,Ñ,P,Q,R,S,T,V,W,X,Y,Z]{3}[0-9,A-Z][0-9]$/',
      ],
      NomDenRazSocB: [
        requiredSI,
        'string',
        'min:1',
        'max:255',
      ],
      ConceptoPago: [
        requiredSI,
        'string',
        'in:1,2,3,4,5,6,7,8,9',
      ],
      DescripcionConcepto: [
        requiredSI,
        'string',
        'min:1',
        'max:255',
      ],
    },
  };
};

export default ComplementoPagosaextranjerosRules;
